import { MemberGroups } from "shared-types";
import { getUserGroup } from "../services/authorization";
import { checkIsCastingBBC } from "./checkIsCastingBBC";

export function checkIsCD() {
  return (
    [MemberGroups.castingDirector, MemberGroups.searchOnlyCD].includes(
      getUserGroup() as MemberGroups
    ) || checkIsCastingBBC()
  );
}
